import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectProfiles = createSelector(
  [
    (store: RootState) => store.profilesList.profilesList,
    (store: RootState) => store.profilesList.searchText,
  ],
  (profilesList, searchText) => {
    searchText = searchText.toLowerCase();
    return profilesList.filter((item) => {
      return item.name?.toLowerCase().includes(searchText);
    });
  }
);
